import * as Events from '@core/events';
import * as apis from '@core/apis';
import { BUILD_EVENT, TComponent } from '@core';
import Field from '@core/managers/Field';
import { EEVents } from '@core/constants';

const triggerTargetValue = (
  target: Field,
  clearedValue: string | number | boolean,
  props: Record<string, unknown>,
): void => {
  const cleared = !clearedValue || clearedValue !== target.data.value;
  target.value = clearedValue;
  target.componentProps = { ...target.componentProps, ...props };

  if (cleared) {
    target.publish(
      BUILD_EVENT(EEVents.ON_FIELD_CLEARED, target.component.name),
    );
  }

  target.rehydrate();
};

export const handler = ({
  field,
  form,
  eventReducedSchema,
}: Pick<
  Events.TEventInformation<unknown>,
  'form' | 'eventReducedSchema' | 'field'
>) => {
  eventReducedSchema?.clearFields.forEach((clearField) => {
    clearField.fields.forEach((fieldName, index) => {
      const targetField = form.fields[fieldName];
      const fieldProp = Array.isArray(clearField.clearedProps)
        ? clearField.clearedProps[index]
        : clearField.clearedProps || {};
      const clearedValue = Array.isArray(clearField.clearedValue)
        ? clearField.clearedValue[index]
        : clearField.clearedValue;
      const validations = Array.isArray(clearField.validations)
        ? clearField.validations[index]
        : clearField.validations;
      const defaultClearedValue = Array.isArray(clearField.defaultClearedValue)
        ? clearField.defaultClearedValue[index]
        : clearField.defaultClearedValue;
      const defaultClearedProps = Array.isArray(clearField.defaultClearedProps)
        ? clearField.defaultClearedProps[index]
        : clearField.defaultClearedProps;
      if (!targetField) return;
      if (!clearField.validations) {
        return triggerTargetValue(targetField, clearedValue, fieldProp);
      }

      const errors = apis.validations.run(
        clearField.useCurrentFieldValidation
          ? field.data.value
          : targetField.value,
        validations,
      );

      if (!targetField.fieldHasError(errors)) {
        if (defaultClearedValue || defaultClearedProps) {
          triggerTargetValue(
            targetField,
            defaultClearedValue,
            defaultClearedProps,
          );
        }
        return;
      }
      triggerTargetValue(targetField, clearedValue, fieldProp);
    });
  });
};

export const events = (component: TComponent) =>
  Object.keys(component.clearFields || {});
